import React, { createContext, useState, useEffect } from "react";

export type Theme = "light" | "dark";
export type ThemeContext = {
  rooTheme: Theme;
  toggler: () => void;
  scrollNavbar?: boolean;
};

export const ThemeContext = createContext<ThemeContext>({} as ThemeContext);

export declare interface ChildrenProp {
  children?: React.ReactNode;
}
export const ThemeProvider = ({ children }: ChildrenProp) => {
  const [rooTheme, setTheme] = useState<Theme>("light");
  const [scrollNavbar, setScrollNavbar] = useState<boolean>(false);

  const changeBackground = () => {
    if (window.pageYOffset >= 10) {
      setScrollNavbar(true);
    } else {
      setScrollNavbar(false);
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", changeBackground);
  }, []);

  const toggler = (): void =>
    setTheme((cur) => (cur === "dark" ? "light" : "dark"));

  return (
    <ThemeContext.Provider value={{ rooTheme, toggler, scrollNavbar }}>
      {children}
    </ThemeContext.Provider>
  );
};
